import { useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import {
	ListRow,
	type ListRowProps,
} from "web_myplann/Shared/Components/ListRow";

type Props = Pick<
	ListRowProps,
	"title" | "subtitle" | "onClick" | "rightSlot"
> & {
	icon: ReactNode;
};

export const RedesignListItemRow: FC<Props> = ({ icon, ...rest }) => {
	const theme = useTheme();

	return (
		<ListRow
			{...rest}
			icon={icon}
			iconBg={theme.palette.grey[100]}
			isLast
			sx={{
				py: 1.4,
				"&:active": { bgcolor: theme.palette.grey[100] },
			}}
		/>
	);
};
